<template>
    <div class="fixed inset-x-0 bottom-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
        <div
            @click="close"
            class="fixed inset-0 transition-opacity"
        >
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <div
            class="relative overflow-hidden transition-all transform bg-white rounded-lg shadow-xl modal sm:max-w-6xl"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
        >
            <div
                @click="prev"
                class="absolute top-0 left-0 w-1/2 h-full sm:block"
            >
            </div>

            <div
                @click="next"
                class="absolute top-0 right-0 w-1/2 h-full sm:block"
            >
            </div>
            <div class="absolute top-0 right-0 hidden pt-4 pr-4 sm:block">
                <button
                    type="button"
                    class="text-gray-400 transition duration-150 ease-in-out hover:text-gray-500 focus:outline-none focus:text-gray-500"
                    aria-label="Close"
                    @click="close"
                >
                    <svg
                        class="w-6 h-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>
            </div>

            <div class="flex-col sm:flex sm:items-start">
                <img
                    class="gallery"
                    :src="photoSrc"
                >
                <div
                    v-if="photoIndex !== null"
                    class="w-full p-3 text-center"
                >{{ photos[photoIndex].created_at | prettydate }}
                </div>
            </div>
        </div>
    </div>
</template>
<style>
img.gallery {
    max-height: 75vh;
}
</style>
<script>
export default {
    props: ["index", "photos"],
    data: () => {
        return {
            photoIndex: null,
            photoSrc:
                "https://www.mariucciabucci.it/assets/uploads/2017/05/background-home.jpg"
        };
    },
    methods: {
        prev() {
            this.photoIndex =
                this.photoIndex - 1 < 0
                    ? this.photos.length - 1
                    : this.photoIndex - 1;
            this.getPhoto();
        },
        next() {
            this.photoIndex =
                this.photoIndex + 1 == this.photos.length
                    ? 0
                    : this.photoIndex + 1;
            this.getPhoto();
        },
        close() {
            this.$destroy();
            this.$el.parentNode.removeChild(this.$el);
        },
        getPhoto() {
            this.$store
                .dispatch("photo/PHOTO", this.photos[this.photoIndex].id)
                .then(data => (this.photoSrc = data));
        }
    },
    mounted() {
        this.photoIndex = this.index;
        this.getPhoto();
    }
};
</script>
